const SupplierActionTypes = {
    LOAD_FILE_IMPORT: 'supplier/load_file_import',
    NEXT_STEP: 'supplier/next_step',
    PREV_STEP: 'supplier/prev_step',
    CANCEL_IMPORT: 'supplier/cancel_import',
    LOADING: 'supplier/loading',
    UPDATE_DATA_IMPORT: 'supplier/update_data_import',
  };
  
  export default SupplierActionTypes;